export default __webpack_public_path__ + "static/media/hand.5d6fd764.svg";